import Cookies from "js-cookie"
import { useSelector } from "react-redux"

import { IS_NA, IS_CA, IS_US, IS_INT, IS_UK } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

export const usePopupTrigger = () => {
  const { isMobile } = useWindowDimensions()
  const geoCookie = Cookies.get("geo")
  const isGeoUS = geoCookie ? geoCookie === "US" : IS_US()
  const isGeoCA = geoCookie ? geoCookie === "CA" : IS_CA()

  const jewlrDaysPopup = useSelector(
    (state) => state.experiment.jewlrDaysPopup.variant_id
  )

  return () => {
    try {
      if (IS_NA() && (isGeoUS || isGeoCA)) {
        const attentiveBoxID = isMobile
          ? isGeoUS
            ? 1306983 // US Mobile
            : 1311719 // CA Mobile
          : isGeoUS
            ? 1306982 // US Desktop
            : 1311567 // CA Desktop
        window.__attentive.trigger(null, null, null, attentiveBoxID)
        // } else if (IS_INT()) {
        //   const globaleBoxID = "aee6786c-941d-4447-a7e9-74364ff13e18" // global e 321134
        //   window.DIGIOH_API.LIGHTBOX.loadLightbox(globaleBoxID)
      } else {
        // const lightboxID = IS_UK()
        //   ? "34635a3c-575b-4569-b7c4-2bb8e0d7f6f8" // 323529
        //   : "acb91908-2c05-44ab-a719-47b5633fff8e" // 325686
        const lightboxID = IS_INT()
          ? "34635a3c-575b-4569-b7c4-2bb8e0d7f6f8" // 323529
          : jewlrDaysPopup === 1
            ? IS_UK()
              ? "e10223f2-48d5-42d4-b241-9ecc5a164ec4" // 329969
              : "40c7f496-f29b-476d-a75f-37dae8bf2d97" // 329970
            : IS_UK()
              ? "110a03af-4252-4c98-bf14-b9c0f156b9ae" // 329714
              : "0935ae84-ed45-4a3d-b597-62d18aae62ae" // 329877
        console.log("Popup trigger", lightboxID)
        window.DIGIOH_API.LIGHTBOX.loadLightbox(lightboxID)
      }
    } catch (err) {
      console.log("Error loading popup: ", err)
    }
  }
}

export default usePopupTrigger
